import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ConfirmModal } from '@app/shared/modals';
import { AppFilter } from '@app/shared/models';
import { SuiModalService, ModalSize } from '@richardlt/ng2-semantic-ui';
import { AuditTrailDetailModal } from 'src/modules/features/admin/modals';
import {
  NewDirectorModal,
  DirectorRecordModal,
  uploadDocumentsModal,
} from '../../../modals';
import { Subject } from 'rxjs';
import { map, take, takeUntil } from 'rxjs/operators';
import { NavigationStart, Router, ActivatedRoute } from '@angular/router';
import {
  CompanyService,
  DashboardProvider,
  DocumentService,
  OrganizationService,
} from '../../../services';
import { ViewHistoryModal } from '../../../modals/view-history-modal/view-history-modal.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-company-shareholder',
  templateUrl: './company-shareholder.component.html',
  styleUrls: ['./company-shareholder.component.scss'],
})
export class CompanyShareholderComponent implements OnInit {
  companyDirectors = [];
  success: any;
  error: any;
  unsubscribe$: Subject<boolean> = new Subject();
  pending: boolean;
  filter: AppFilter = new AppFilter();
  totalItems: number = 0;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  organizationId: string;
  companyType: Array<any> = [];
  ownershipType: Array<any> = [];
  countries: Array<any> = [];
  isEdit: boolean = false;
  isPending: boolean = false;
  chatLink;
  companyShareholderForm: FormGroup;
  currentForm: FormGroup;
  changeRequestId;
  result = [];
  documents = [];
  searchFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'firstName',
        op: 'cn',
        data: '',
      },
      {
        field: 'createdBy',
        op: 'cn',
        data: '',
      },
      {
        field: 'organizationOwnershipTypeId',
        op: 'cn',
        data: '',
      },
    ],
  };
  optionFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'individual_ownership_type',
      },
    ],
  };
  directorStatus: string;
  message;
  redirect_url;
  applicationType;
  constructor(
    private modalService: SuiModalService,
    private location: Location,
    private dashboardSvc: DashboardProvider,
    private companySvc: CompanyService,
    private organizationSvc: OrganizationService,
    private fb: FormBuilder,
    private documentSvc: DocumentService,
    private router: Router
  ) {
    this.message = window.localStorage.getItem('message');
    this.applicationType = window.localStorage.getItem('application_type');
    this.redirect_url = window.localStorage.getItem('redirect_url');
    this.organizationId = window.localStorage.getItem('organizationId');
    this.filter = new AppFilter({ sidx: 'dateCreated', rows: 10 });
    this.getVerificationStatus();
    this.getPage(1);
    this.getCountry();
    this.getOptionTypes();

    this.chatLink = `/contractor/chat/${this.organizationId}/message`;
    // this.activatedRoute.parent.params.subscribe((params) => {
    // 	this.projectId = params['id'];
    // });

    this.companyShareholderForm = fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      middleName: [''],
      gender: ['', Validators.required],
      nationalityId: ['', Validators.required],
      countryOfOriginId: ['', Validators.required],
      nationalIdNumber: ['', Validators.required],
      organizationOwnershipTypeId: [''],
      shareholding: [''],
      actionType: [''],
      organizationOwnershipId: [''],
    });
    this.currentForm = this.companyShareholderForm.value;
  }
  getCountry() {
    this.companySvc.getCountries({ filter: null }).subscribe((res) => {
      this.countries = res['rows'];
    });
  }
  getOptionTypes() {
    this.companySvc
      .getOptions({ filter: JSON.stringify(this.optionFilter) })
      .pipe(map((res: any) => res.rows))
      .subscribe((res) => {
        this.ownershipType = res;
      });
  }

  updateForm(data) {
    this.nullify();
    this.companyShareholderForm.value.actionType = 'DELETE';
    this.currentForm = this.companyShareholderForm.value;
    this.currentForm['actionType'] = 'DELETE';
    this.companyShareholderForm.value.organizationOwnershipId =
      data.organizationOwnershipId;
    this.currentForm['organizationOwnershipId'] = data.organizationOwnershipId;
    let payload = {
      fromValue: this.currentForm,
      toValue: this.companyShareholderForm.value,
    };
    this.result.push(payload);
    this.success =
      'Update Successful . Ensure you save so that the request can undergo verification';
  }
  checkifisthesame(data) {
    console.log(data);
    const organizationOwnershipIds = data.map((o) => o.organizationOwnershipId);
    const filtered = data.filter(
      ({ organizationOwnershipId }, index) =>
        !organizationOwnershipIds.includes(organizationOwnershipId, index + 1)
    );
    return filtered;
  }
  getPage(page) {
    this.filter.page = page;
    this.pending = true;
    this.companySvc
      .getCompanyDirector({
        organizationId: this.organizationId,
        ownershipType: 'shareholder_type',
        params: this.filter,
      })
      .subscribe(
        (res: any) => {
          this.totalItems = +res.records;
          this.rows = this.filter.rows;
          this.companyDirectors = res['rows'];
          this.pending = false;
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }

  addCompany() {}
  viewCompany(event) {
    this.modalService
      .open(
        new AuditTrailDetailModal(
          'Row Data',
          'Are you sure you want to delete this Lot plan?',
          ModalSize.Tiny
        )
      )
      .onApprove((payload) => {
        // this.addWorkflowGroup(payload);
      })
      .onDeny(() => {});
  }
  getCountryName(cou) {
    let con = this.countries.filter((con) => con.countryCode == cou);
    if (con[0]) {
      return con['countryName'];
    } else {
      return cou;
    }
  }

  getOwnership(cou) {
    let con = this.ownershipType.filter((con) => con.optionId == cou);
    if (con[0]) {
      return con['optionName'];
    } else {
      return cou;
    }
  }

  viewHistory() {
    this.modalService.open(
      new ViewHistoryModal('View History', 'SHAREHOLDER_STRUCTURE', {
        isPending: false,
      })
    );
  }

  addDirector() {
    this.modalService
      .open(
        new NewDirectorModal(
          'New Director/Shareholder',
          {
            countries: this.countries,
            companyType: this.companyType,
            ownershipType: this.ownershipType,
            item: 'SHAREHOLDER_STRUCTURE',
          },
          false,
          ModalSize.Tiny
        )
      )
      .onApprove((values: any) => {
        let data = {
          fromValue: values.fromValue,
          toValue: values.toValue,
        };
        this.result.push(data);
        this.documents.push(values.document);
        // this.getPage(1);
      })
      .onDeny(() => {});
  }

  edit(director) {
    console.log(director, 'data');
    this.modalService
      .open(
        new NewDirectorModal(
          'Edit Shareholder',
          {
            director: director,
            countries: this.countries,
            companyType: this.companyType,
            ownershipType: this.ownershipType,
            item: 'SHAREHOLDER_STRUCTURE',
          },
          true,
          ModalSize.Tiny
        )
      )
      .onApprove((values: any) => {
        let data = {
          fromValue: values.fromValue,
          toValue: values.toValue,
        };
        this.result.push(data);
        console.log(this.result, 'here');
        this.documents.push(values.document);
      })
      .onDeny(() => {});
  }

  upload() {
    this.modalService
      .open(
        new uploadDocumentsModal(
          'Upload Documents',
          {
            countries: this.countries,
            companyType: this.companyType,
            ownershipType: this.ownershipType,
            item: 'SHAREHOLDER_STRUCTURE',
          },
          true,
          ModalSize.Tiny
        )
      )
      .onApprove((values: any) => {
        this.documents.push(values.document);
      })
      .onDeny(() => {});
  }
  directorRecord(director) {
    this.modalService
      .open(
        new DirectorRecordModal(
          'Shareholder Details',
          {
            director: director,
            countries: this.countries,
            companyType: this.companyType,
            ownershipType: this.ownershipType,
            item: 'SHAREHOLDER_STRUCTURE',
          },
          ModalSize.Tiny
        )
      )
      .onApprove(() => {})
      .onDeny(() => {});
  }
  checkDoc() {
    if (this.documents.length > 0) {
      this.isEdit = false;
      this.saveActionDirector();
    } else {
      this.upload();
    }
  }
  saveDirector() {
    if (this.result.length > 0) {
      this.checkDoc();
    } else {
      this.error = 'Please perform an action';
    }
  }
  structure = [];
  saveActionDirector() {
    this.modalService
      .open(
        new ConfirmModal(
          'Save Updates',
          "Are you sure you want to save these updates to the shareholders' structure?",
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        let data = this.companyDirectors.filter(
          (elem) =>
            !this.result.find(
              ({ toValue }) =>
                elem.organizationOwnershipId === toValue.organizationOwnershipId
            )
        );
        data.map((item) => {
          let dataSent = {
            countryOfOriginId: item.countryOfOriginId,
            firstName: item.firstName,
            gender: item.gender,
            lastName: item.lastName,
            middleName: item.middleName,
            nationalIdNumber: item.nationalIdNumber,
            nationalityId: item.nationalityId,
            organizationOwnershipId: item.organizationOwnershipId,
            organizationOwnershipTypeId: item.organizationOwnershipTypeId,
            shareholding: item.shareholding,
          };
          return this.structure.push(dataSent);
        });
        // console.log(data, 'filtered');
        this.saveAll();
      });
  }
  nullify() {
    this.success = '';
    this.error = '';
  }

  saveAll() {
    this.pending = true;
    let toValue = [];
    let fromValue = [];
    this.result.map((item) => {
      toValue.push(item.toValue);
      fromValue.push(item.fromValue);
    });
    this.structure.map((data) => {
      fromValue.push(data);
    });
    let resultFrom = this.checkifisthesame(fromValue);
    let resultTo = this.checkifisthesame(toValue);
    let payload = {
      organization: {
        organizationId: this.organizationId,
      },
      changeRequestType: 'SHAREHOLDER_STRUCTURE',
      actionType: 'UPDATE',
      fromValue: JSON.stringify(resultFrom),
      toValue: JSON.stringify(resultTo),
    };
    console.log(payload, 'payload');
    this.organizationSvc
      .addChangeRequest({
        organizationId: this.organizationId,
        body: payload,
      })
      .subscribe(
        (res) => {
          this.changeRequestId = res['changeRequestId'];
          // this.input.nativeElement.focus();
          if (this.documents.length > 0) {
            this.documents.map((item) => {
              this.onUploadFile(item);
            });
          } else {
            this.pending = false;
            this.success =
              'Shareholder details updated successfully. You will be notified when your request has been verified';
            this.getVerificationStatus();
          }
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  onUploadFile(data) {
    this.nullify();
    this.pending = true;
    this.documentSvc
      .uploadSupportingDocument({
        changeRequestId: this.changeRequestId,
        body: data,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success =
            'Shareholder details updated successfully. You will be notified when your request has been verified';
          this.getVerificationStatus();
          // } else {
          //   this.success =
          //     'Director details updated successfully. You will be notified when your request has been verified';
          // }
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  viewUpdates() {}

  updateDirector() {
    this.modalService
      .open(
        new ConfirmModal(
          'Make Updates',
          "Are you sure you want to make updates to the shareholders' structure?",
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.isEdit = true;
      });
  }

  getVerificationStatus() {
    let organization = JSON.parse(window.localStorage.getItem('organization'));
    this.dashboardSvc
      .getStatus({
        organizationId: organization.organizationId,
      })
      .subscribe(
        (res) => {
          this.directorStatus = res['SHAREHOLDER_STRUCTURE'];
          res['SHAREHOLDER_STRUCTURE'] === 'UNVERIFIED' ||
          res['SHAREHOLDER_STRUCTURE'] === 'PENDING'
            ? (this.isPending = true)
            : (this.isPending = false);
        },
        (error) => {
          this.directorStatus = 'NOT_AVAILABLE';
          this.isPending = false;
          // this.error = error.error.errorMessage ? error.error.errorMessage
          //                                       : error.error ? error.error
          //                                       : error;
        }
      );
  }

  onDelete() {}

  deleteItem(director) {
    this.companyShareholderForm.patchValue(director);
    this.modalService
      .open(
        new ConfirmModal(
          'Delete Record',
          'Are you sure you want to delete this Record?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.updateForm(director);
      })
      .onDeny(() => {});
  }
  goBack() {
    this.location.back();
  }
  searchRecords(search) {
    let searchFilter = {
      groupOp: 'OR',
      rules: [
        {
          field: 'firstName',
          op: 'cn',
          data: '',
        },
        {
          field: 'lastName',
          op: 'cn',
          data: '',
        },
        // {
        //   field: 'organizationOwnershipTypeId',
        //   op: 'cn',
        //   data: '',
        // },
      ],
    };
    searchFilter.rules[0].data = search;
    searchFilter.rules[1].data = search;
    // searchFilter.rules[2].data = search;
    this.filter.filters = JSON.stringify(searchFilter);
    this.getPage(1);
  }
  //handle sorting records
  sortRecords(search) {
    this.filter.sord = search;
    // this.filter.sidx = 'firstName';
    this.getPage(1);
  }

  //handles rows display
  displayRecords(row) {
    this.filter['rows'] = row;
    this.getPage(1);
  }

  nextPage(page: number) {
    //get and assign current page
    this.currentPage = page;
    this.getPage(this.currentPage);
  }

  ngOnInit(): void {
    this.router.events.pipe(takeUntil(this.unsubscribe$)).subscribe((event) => {
      if (
        event instanceof NavigationStart &&
        event.url != `/contractor/company/shareholder`
      ) {
        localStorage.removeItem('message');
        localStorage.removeItem('application_type');
        localStorage.removeItem('redirect_url');
      }
    });
  }
}
